import { IParticipant, ITrack, IRoot, } from "./../models/meeting";
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { AppThunk } from "src/store";
import { ScreenSharing, resourceInfo, setGamificationDrawer, stopSharingSelf } from "./AvToolbar";
import axios from "src/utils/axios";
import {  TrainerNotification } from "./myMachines";
import { setAllowPermission } from "./waitingAV";
import store from "src/store";
import { set360view, removePresenterAccess, removePresenterAccessUpdate, editorActions } from "./editor";
import { fetchingGourpData } from "./events/Resource_Assignment";
import jwt_decode from "jwt-decode";
import { FailureSnackbar } from "./snackbar";
import { startScreenShareLivekit, stopScreenShareLivekit } from "./livekitMeeting";

const BASE_URL = process.env.REACT_APP_API_URL;

type CONTEXTID = {
  sub: string;
  contextId: string;
};

const initialState: IRoot = {
  room: {
    participants: {}, // object key = id
    localTracks: {},
    remoteTracks: [],
    muteRoom: true,
    stopAllVideo: false,
    stopAllScreenShare: false,
    roomInstance: {},
    mediaDevices: [],
  },
  isChatWIndowOpen: false,
  isSettingWindowOpen: false,
  isParticipantsViewWIndowOpen: false,
  roomName: "",
  userName: "",
  emailId: "",
  userLeft: "",
  isLeft: false,
  roomJoined: false,
  notification: {
    type: "default",
    message: "",
  },
  toolBarOptions: {
    showConference: true,
    showEditor: true,
    showVdi: true,
    showVideo: true,
    showAudio: true,
    showScreenShare: true,
    showParticipants: true,
    showChat: true,
    showSettings: true,
    showEnd: true,
    showFullScreen: true,
    showRaiseHand: true,
    screenshared: false,
    openDailog: false,
    openVdidailog: false,
    notAllowed: false,

  },
  toolBarValues: {
    conferenceStatus: false,
    editorStatus: false,
    vdiStatus: false,
    videoStatus: true,
    audioStatus: true,
    screenShareStatus: false,
    participantsStatus: false,
    chatStatus: false,
    settingsStatus: false,
    endStatus: false,
    fullScreenStatus: false,
    raiseHandStatus: false,
  },
  hostDetailsList: [],
  lockMeeting: false,
  makePlaybookCompatible: false,
  recordCount: 0,
  skipMeeting: false,
  enableVideo: false,
  enable360Degree: false,
  enableGamification: false,
  muteParticipantWhenJoining: false,
  soundNotificationonJoinOrLeave: false,
  allowRecording: false,
  setExpiryDateCheckBox: false,
  setExpiryDate: `${new Date(
    new Date().setDate(new Date().getDate() + 1)
  ).toISOString()}`,
  setExpiryDateLoader: false,
  roles: [],
  selectedRole: "",
  openRoleModal: false,
  openKickoutModal: false,
  createdById: "",
  jitsiToken: "",
  selectedUserId: "",
  isNoiseSuppressionActivated: undefined,
  outputDeviceId: "default",
  Cancel:"",
  recordingPreference: {
    access: "",
    selected: [],
    external: [],
  },
  playbookScreenShare: false,
  agentJoined: false,
  showTheTileAfterAgentJoins: false,
  recordingStartedBy: "",
  recordingStarted:false,
};

const slice = createSlice({
  name: "meeting",
  initialState,
  reducers: {
    setToolBarOptions(
      state: IRoot,
      action: PayloadAction<{ name: string; value: boolean }>
    ) {
      state.toolBarValues[action.payload.name] = action.payload.value;
    },
    setRoomInstance(
      state: IRoot,
      action: PayloadAction<{ roomInstance?: any; roomJoined: boolean }>
    ) {
      state.room.roomInstance = action.payload.roomInstance;
      state.roomJoined = action.payload.roomJoined;
    },
    addParticipant(
      state: IRoot,
      action: PayloadAction<{ participant: IParticipant }>
    ) {
      const participants = state.room.participants;
      Object.assign(participants, {
        [action.payload.participant.participantId]: {
          ...action.payload.participant,
        },
      });
      state.room.participants = participants;
    },
    removeParticipant(state: IRoot, action: PayloadAction<{ id: string }>) {
      // const remotetracks= state.room?.participants[action.payload.id]?.tracks['audio']
      // remotetracks.detach(action.payload.id+remotetracks.trackType)
      if (action.payload.id) {
        const participants = state.room.participants;
        state.userLeft = participants[action.payload.id]?.displayName;
        delete participants[action.payload.id];
        state.room.participants = participants;
      }
    },
    addRemoteTrack(state: IRoot, action: PayloadAction<{ track }>) {
      const track = action.payload?.track;
      if (!track) {
        return;
      }
      const trackOwnerId =
        track?.trackOwnerId ||
        track.trackInformationInstance?.getParticipantId();
        if(state.room.participants[trackOwnerId]){
          state.room.participants[trackOwnerId].tracks[track.trackType] = track;
        }
    },
    addaudioLevel(state: IRoot, action: any) {
      const level = action?.payload?.level;
      const id = action?.payload?.id;
      state.room.participants[id].audioLevel = level;
    },

    removeRemoteTrack(
      state: IRoot,
      action: PayloadAction<{ type; trackOwnerId }>
    ) {
      const { type, trackOwnerId } = action.payload;
      if (type === "desktop" || type === "video") {
        state.room.participants[trackOwnerId].tracks["video"] = {};
        delete state.room.participants[trackOwnerId].tracks["video"];
        state.room.participants[trackOwnerId].tracks["desktop"] = {};
        delete state.room.participants[trackOwnerId].tracks["desktop"];
        return;
      }
      state.room.participants[trackOwnerId].tracks[type] = {};
      delete state.room.participants[trackOwnerId].tracks[type];
    },
    changeRemoteTrackProperties(
      state: IRoot,
      action: PayloadAction<{
        propertyName: string;
        value: true | false;
        trackOwnerId: string;
        trackType: string;
      }>
    ) {
      const { propertyName, value, trackOwnerId, trackType } = action.payload;
      const track = state.room.participants[trackOwnerId]?.tracks[trackType];
      if (track) {
        if (!Object.keys(track).includes(propertyName)) {
          return;
        }
        track[propertyName] = value;
        state.room.participants[trackOwnerId].tracks[trackType] = track;
      }
    },
    addLocalTrack(state: IRoot, action: PayloadAction<{ track }>) {
      state.room.localTracks[action.payload.track.trackType] =
        action.payload.track;
    },
    setSharedAudioTrack(state: any, action: PayloadAction<{track}>){
      state.room.localTracks.sharedAudio = action.payload.track;
    },
    toggleAudio(state: IRoot) {
      state.room.localTracks.audio = {};
    },
    mediaDevices(state: IRoot, action) {
      state.room.mediaDevices = action.payload;
    },
    kickout(
      state: IRoot,
      action: PayloadAction<{ kickout: boolean; id: string }>
    ) {
      state.room.participants[action.payload.id].isKickedOut =
        action.payload.kickout;
    },
    sendNotification(state: IRoot, action: PayloadAction<{ type; message }>) {
      state.notification = {
        type: action.payload.type,
        message: action.payload.message,
      };
    },
    userLeft(state, action) {
      state.isLeft = action.payload;
    },
    hostDetails(state, action) {
      state.hostDetailsList = action.payload;
    },
    setLockMeeting(state, action) {
      state.lockMeeting = action.payload;
    },
    setMakePlaybookCompatible(state, action) {
      state.makePlaybookCompatible = action.payload;
    },
    setRecordCount(state, action) {
      state.recordCount = action.payload;
    },
    setSkipMeeting(state, action) {
      state.skipMeeting = action.payload;
    },
    setEnableVideo(state, action) {
      state.enableVideo = action.payload;
    },
    setEnable360Degree(state, action) {
      state.enable360Degree = action.payload;
    },
    setEnableGamification(state, action) {
      state.enableGamification = action.payload;
    },
    setMuteParticipantWhenJoining(state, action) {
      state.muteParticipantWhenJoining = action.payload;
    },
    setEntryExitSound(state, action) {
      state.soundNotificationonJoinOrLeave = action.payload;
    },
    setRecordingPreference(state, action) {
      state.recordingPreference = action.payload;
    },
    setAllowRecording(state, action) {
      state.allowRecording = action.payload;
    },
    setAudioOutputDevice(state, action) {
      state.outputDeviceId = action.payload;
    },
    setExpiryDate(state, action) {
      state.setExpiryDate = action.payload;
    },
    setExpiryDateCheckBox(state, action) {
      state.setExpiryDateCheckBox = action.payload;
    },
    setExpiryDateLoader(state, action) {
      state.setExpiryDateLoader = action.payload;
    },
    setRoleList(state, action) {
      state.roles = action.payload;
    },
    selectedRole(state, action) {
      state.selectedRole = action.payload;
    },
    openRoleModal(state, action) {
      state.openRoleModal = action.payload;
    },
    openKickoutModal(state, action) {
      state.openKickoutModal = action.payload;
    },
    createdById(state, action) {
      state.createdById = action.payload;
    },
    resetParticipantRoles(state, action) {
      state.room.participants = action.payload;
    },
    roleUpdate(state, action) {
      const { data, participants } = action.payload;

      let replaceObjectId;
      for (const key in participants) {
        const currentObject = participants[key];

        if (currentObject.userId === data?.participantId) {
          replaceObjectId = currentObject?.participantId;
          break;
        }
      }
      if (replaceObjectId) {
        state.room.participants[replaceObjectId].role = data?.roleName;
        state.room.participants[replaceObjectId].eventHost = (data?.roleName === "Host");
      }
    },
    setJitsyToken(state, action) {
      state.jitsiToken = action.payload;
    },
    selectedUserId(state, action) {
      state.selectedUserId = action.payload;
    },
    setNoiseSuppressionActivated(state, action){
      state.isNoiseSuppressionActivated = action.payload;
    },
    setScreenshare(state, action) {
      state.toolBarOptions.screenshared = action.payload;
    },
    setOpenModel(state, action) {
      state.toolBarOptions.openDailog = action.payload;
    },
    setNotAllowed(state, action) {
      state.toolBarOptions.notAllowed = action.payload;
    },
    setCancel(state,action){
      state.Cancel=action.payload;
    },
    setPlaybookScreenShare(state, action) {
      state.playbookScreenShare = action.payload;
    },
    setAgentJoined(state, action) {
      state.agentJoined = action.payload;
    },
    setRecordingStartedBy(state, action) {
      state.recordingStartedBy = action.payload;
    },
    ClearRecordingStartedBy(state) {
      state.recordingStartedBy = "";
    },
    setRecordingStarted(state, action) {
      state.recordingStarted = action.payload;
    },
    setShowTheTileAfterAgentJoins(state, action) {
      state.showTheTileAfterAgentJoins = action.payload;
    },
  },
});
export const meetingactions=slice.actions;
/* eslint-disable */
export const toolBarAction =
  (toolbarNameToModify: string, newValue: boolean): AppThunk =>
    async (dispatch) => {
      dispatch(
        slice.actions.setToolBarOptions({
          name: toolbarNameToModify,
          value: newValue,
        })
      );
    };

export const getAvailableDevices = (): AppThunk => async (dispatch) => {
  const devices = await navigator.mediaDevices.enumerateDevices();
  dispatch(slice.actions.mediaDevices(devices));
};

export const RemotetrackMute =
  (ID): AppThunk =>
    async (dispatch) => {
      try {
        const response = await axios.post(
          `${BASE_URL}/events/api/v1/events/mute?id=${ID}&action=MUTE&all=false`
        );
        if (response?.data?.status) {
          dispatch(TrainerNotification(response?.data?.message));
        }
      } catch (error) {
        throw new Error(error);
      }
    };

export const RemotetrackUnmute =
  (ID): AppThunk =>
    async (dispatch) => {
      try {
        const response = await axios.post(
          `${BASE_URL}/events/api/v1/events/mute?id=${ID}&action=UNMUTE&all=false`
        );
        if (response?.data?.status) {
          dispatch(TrainerNotification(response?.data?.message));
        }
      } catch (error) {
        throw new Error(error);
      }
    };
export const RemotetrackMuteAllAPI =
  (): AppThunk =>
    async (dispatch) => {
      try {
        const response = await axios.post(
          `${BASE_URL}/events/api/v1/events/mute?action=MUTE&all=true`
        );
        //to check the working of response
        // if (response?.data?.status) {
        //   dispatch(TrainerNotification(response?.data?.message));
        // }
      } catch (error) {
        throw new Error(error);
      }
    };
/**
 *! Create a video/audio element and appends it to the owner node. Only for Remote Tracks.
 * @param track | Track
 * @returns
 */
export const createTrackNodeAndAppend =
  (track): AppThunk =>
    async () => {
      const trackOwnerId = track.getParticipantId();
      const trackType = track.getType();
      const trackOwnerContainer = document.getElementById(trackOwnerId);
      const trackId = trackOwnerId + "-" + trackType;
      const newTrack = document.createElement(trackType);
      newTrack.id = trackId;
      newTrack.autoplay = true;
      trackOwnerContainer.appendChild(newTrack);
      track.attach(document.getElementById(trackId));
    };
/* eslint-disable */

export const toggleDesktopTrack =
  (
    hitUnshareAPI = false,
    sharing = false,
    alreadyScreenShared = false,
    force = false
  ): AppThunk =>
  async (dispatch, getState) => { 
    dispatch(slice.actions.setOpenModel(false));

    const room: any = getState()?.meeting?.room;
    if (sharing) {
      dispatch(startScreenShare(room, alreadyScreenShared, force));
    } else if (room?.localTracks?.desktop){      
           dispatch(ScreenSharing(false));
      dispatch(stopScreenShare());
    }
  };
const startScreenShare =
  (room, alreadyScreenShared, force): AppThunk =>
  async (dispatch, getState) => {
          if (alreadyScreenShared) {
            dispatch(stopSharingSelf());
          }
            const response = await axios.put(
              `${BASE_URL}/events/api/v1/events/screen-share/SHARE?force=${force}`
            );
            if(!response){
              return;
            }
            try {
            if (response?.data?.status) {
              dispatch(ScreenSharing(true));
              dispatch(startScreenShareLivekit());
              const ymapPreference = getState()?.editor?.ymapPreference;
              if (ymapPreference && force) {
                 const presentVdi = ymapPreference.get("present_vdi");
                 if (presentVdi?.status) {
                   const presenterDevice = getState()?.editor?.vdiInfoRead?.device;
                   dispatch(removePresenterAccessUpdate());
                   dispatch(editorActions.setIsStoppingPresenter(true));
                   ymapPreference.set("present_vdi", {
                      ...presentVdi,
                      status: false
                   });
                   ymapPreference.set("vdi_sharing_removed", {
                      status: true,
                      participant_name: getState().messages?.name || "",
                      participant_id: getState().messages?.user_id || "",
                      timestamp: Date.now(),
                    });
                   if (presenterDevice) {
                     dispatch(removePresenterAccess(presenterDevice));
                   }
                 }
              }
            }
            else if(!response?.data?.status ){
              force ?dispatch(slice.actions.setNotAllowed(true)):dispatch(slice.actions.setOpenModel(true));
              return;
            }
          } catch (e) {
            throw new Error(e);
          }
  };

export const stopScreenShare = () => async (dispatch) => { 
    dispatch(stopScreenShareLivekit());
    await axios.put(`${BASE_URL}/events/api/v1/events/screen-share/UNSHARE`);
};

export const updateRoomleft = (data: boolean): AppThunk => async (dispatch) => {
  dispatch(slice.actions.userLeft(data));
};

// get roles
export const getRolesAPI = (Id: string, userRole: string) => async (dispatch) => {
  try {
    const response = await axios.get(`${BASE_URL}/events/api/v1/events/roles`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        contextId: Id,
      },
    });
    if (response?.status === 200 && response?.data?.status) {
      const filteredRoles = response?.data?.data?.filter((role) => role?.name !== userRole);
      dispatch(slice.actions.setRoleList(filteredRoles || []));
      dispatch(slice.actions.selectedRole(filteredRoles[0]?.allowed ? filteredRoles[0]?.id : ""));
    } else {
      dispatch(slice.actions.setRoleList([]));
      dispatch(slice.actions.selectedRole(""));
    }
  } catch (error) {
    dispatch(slice.actions.setRoleList([]));
    dispatch(slice.actions.selectedRole(""));
    throw new Error(error);
  }
};

// change role 
export const changeRoleAPI = (id: string, roleId: string, enqueueSnackbar: any, participants: any) => async (dispatch) => {
  try {
    const response = await axios.put(`${BASE_URL}/aacl/api/v1/roles/${id}`, {
      roleId
    });
    
    if (response?.status === 200 && response?.data?.status) {
      enqueueSnackbar(response?.data?.message, {
        variant: "success",
        preventDuplicate: false,
        autoHideDuration: 5000,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      });
      dispatch(slice.actions.openRoleModal(false));
    } else {
      throw new Error(response?.data?.message || "Failed to change role");
    }
  } catch (error) {
    enqueueSnackbar(error?.message || error || "Failed to change role", {
      variant: "error",
      preventDuplicate: true,
      autoHideDuration: 5000,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right",
      },
    });
    throw new Error(error);
  }
};

// kickout participant
export const kickoutparticpant = (id): AppThunk => async (dispatch) => {
  try {
    const response = await axios.patch(`${BASE_URL}/events/api/v1/participants/kick-out/${id}?destroyMachines=true`);
    if (response.data.status) {
      dispatch(TrainerNotification(response.data.message));
    } else {
      dispatch(TrainerNotification(response.data.message, "error"));
    }
  } catch (error) {
    dispatch(TrainerNotification(error?.message, "error"));
    throw new Error(error);
  }
};

//Lower hand of Participant by host / trainer
export const handleLowerHand = (participantId): AppThunk => async (dispatch) => {
  try {
    const response = await axios.post(`${BASE_URL}/events/api/v1/events/participant-lower-hand?id=${participantId}`,{
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    if (!response.data.status) {
      dispatch(
        FailureSnackbar({
          message: response.data.message || "Failed to lower hand",
          open: true,
        })
      );
      setTimeout(() => {
        dispatch(
          FailureSnackbar({
            message: "",
            open: false,
          })
        );
      }, 3000);
    } 
  } catch (error) {
    throw new Error(error);
  }
}
const getTrackData = (track) => {
 return new Promise((resolve) => {
    try {
      const trackData: ITrack = {
        trackInformationInstance: track,
        isMuted: track?.isMuted(),
        // muted: track.mute(),
        trackType: track.type,
        // deviceId : track.getDeviceId(),
        trackId: track.track.id,
        trackDeviceName: track.track.label,
        containerAttached: track.containers,
        trackOwnerId: track?.getParticipantId(),
        isLocal: track?.isLocal(),
      };
      setTimeout(async () => {
        const trackVideoType = await track.getVideoType();
        if (track.type === "video" && trackVideoType === "desktop") {
          trackData.trackType = trackVideoType;
        }
        resolve(trackData);
      }, 1000);
    } catch (error) {
      throw new Error(error);
    }
  });
};

export const attachingTrack = (Data) => async (dispatch) => {
  try {
    const trackData: any = await getTrackData(Data);
    dispatch(slice.actions.addRemoteTrack({ track: trackData }));
  } catch (e) {
    throw new Error(e);
  }
};

export const setSkipAndLockMeeting1 =
  (data, id, type, enqueueSnackbar) => async (dispatch) => {
    try {
      const publishResponse = await axios.put(
        `${BASE_URL}/events/api/v1/events/${id}/preference`,
        data
      );
      if (!publishResponse?.data?.status) {
        throw new Error(publishResponse?.data?.message);
      }
      if (publishResponse?.data?.status) {
        if (type === "lock" || type === "skip") {
          enqueueSnackbar(publishResponse?.data?.message, {
            variant: "success",
            preventDuplicate: true,
            autoHideDuration: 5000,
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "right",
            },
          });
        }
        if (type === "lock") {
          dispatch(slice.actions.setLockMeeting(data.disableWaitingRoom));
        } else if (type === "skip") {
          dispatch(slice.actions.setSkipMeeting(data.skipWaitingRoom));
        } else if(type === "allowRecording") {
          dispatch(
            slice.actions.setAllowRecording(data.allowParticipantToRecord)
          );
        } else if (type === "video") {
          dispatch(slice.actions.setEnableVideo(data?.video));
        }
      }
    } catch (error) {
      enqueueSnackbar(error?.message || error || "Failed", {
        variant: "error",
        preventDuplicate: true,
        autoHideDuration: 5000,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      });
    }
  };

export const setRecordingExpiryDate =
  (data: any, id: any, enqueueSnackbar: any) => async (dispatch) => {
    try {
      dispatch(slice.actions.setExpiryDateLoader(true));
      const publishResponse = await axios.put(
        `${BASE_URL}/events/api/v1/events/${id}`,
        data,
        { headers: {
          contextId: id,
        } }
      );
      if (!publishResponse?.data?.status) {
        throw new Error(publishResponse?.data?.message);
      }
      if (publishResponse?.data?.status) {
        dispatch(slice.actions.setExpiryDateLoader(false));
        dispatch(slice.actions.setExpiryDateCheckBox(data.recordingExpiryEnabled ?? true));
        dispatch(slice.actions.setExpiryDate(data.recordingExpiryDate));
      }
    } catch (error) {
      dispatch(slice.actions.setExpiryDateLoader(false));
      enqueueSnackbar(error?.message || error || "Failed", {
        variant: "error",
        preventDuplicate: true,
        autoHideDuration: 5000,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      });
    }
  };

export const getPreferences = (id: any) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/events/api/v1/events?id=${id}`
    );
    if (response?.status === 200) {
      dispatch(slice.actions.setAllowRecording(response?.data?.data[0]?.preferences?.allowParticipantToRecord));
      dispatch(slice.actions.setExpiryDate(response?.data?.data[0]?.recordingExpiryDate));
      dispatch(slice.actions.setExpiryDateCheckBox(response?.data?.data[0]?.recordingExpiryEnabled ?? false));
      dispatch(slice.actions.setSkipMeeting(response?.data?.data[0]?.preferences?.skipWaitingRoom));
      dispatch(slice.actions.setLockMeeting(response?.data?.data[0]?.preferences?.disableWaitingRoom));
      dispatch(slice.actions.setEnableVideo(response?.data?.data[0]?.preferences?.video));
      dispatch(slice.actions.setMakePlaybookCompatible(response?.data?.data[0]?.preferences?.makePlaybookCompatible));
      dispatch(slice.actions.setRecordingPreference(response?.data?.data[0]?.preferences?.recording));
      dispatch(slice.actions.setShowTheTileAfterAgentJoins(response?.data?.data[0]?.preferences?.showTheTileAfterAgentJoins));
    } else {
      throw new Error();
    }
  } catch (error) {
    throw new Error();
  }
};

export const fetchAgentStatus = (eventId: string) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/events/api/v1/playbook/agentStatus`,
    );
    if (response?.data?.status) {
      dispatch(slice.actions.setAgentJoined(response?.data?.status));
    }
  } catch (error) {
    throw new Error();
  }
};

export const ParticipantRecordMsg = (enqueueSnackbar, data) => async (dispatch) => {
  const participants = store.getState().meeting?.room?.participants;
  dispatch(slice.actions.roleUpdate({ data: data?.response, participants }));

  const getToken = localStorage.getItem("token");
  try {
    if (getToken) {
      const data = await axios.post(`${process.env.REACT_APP_API_URL}/aacl/api/v1/users/refresh-token`, { access_token: localStorage.getItem("token") });
      dispatch(setAllowPermission(data.data.data.role));

      localStorage.setItem("token", data.data.data.access_token);
    }
    (process.env.REACT_APP_MODE === "DEVELOPMENT" && enqueueSnackbar("Participants are allowed to record", {
      variant: "success",
      preventDuplicate: true,
      autoHideDuration: 5000,
      anchorOrigin: {
        vertical: "top",
        horizontal: "right",
      },
    }))
  } catch (error) {
    throw new Error(error);
  }
};

export const handleVideoDisable = () => async(dispatch, getState) => {
  try {
    const camera = getState()?.meeting?.room?.localTracks?.camera;
    if(camera && !camera?.trackInformationInstance.isMuted()) {
      await camera?.trackInformationInstance?.mute();
      await camera?.roomInstance?.replaceTrack(camera?.trackInformationInstance, null);
    }
  } catch (error) {
    throw new Error(error);
  }
}

// clear all states if role is participants
export const clearAllDrawerStates = (data) => async (dispatch) => {
  if (data?.response?.roleName === "Participant") {
    dispatch(setGamificationDrawer(false));
    dispatch(resourceInfo(false));
    dispatch(set360view(false));
  }
  const CONTEXT: CONTEXTID = jwt_decode(localStorage.getItem("token"));
    dispatch(
      fetchingGourpData(
        CONTEXT.contextId,
        true,
        "",
        true
      )
    );
};

export const reducer = slice.reducer;
export const meetingActions = slice.actions;
export default slice;
